<template>
  <div id="app">
    <Header />
    <router-view></router-view>
    <ToTop />
  </div>
</template>
<script>
import Header from './components/Header'
import ToTop from './components/ToTop'

export default {
  name: 'russellfuller.com',
  components: {
    Header,
    ToTop,
  },
  data() {
    return {}
  },
}
</script>

<style lang="scss">
@import url('https://use.typekit.net/biq2prq.css');
@import url('https://fonts.googleapis.com/css?family=Nunito&display=swap');
@import url('https://fonts.googleapis.com/css?family=Frank+Ruhl+Libre&display=swap');
@import url('https://fonts.googleapis.com/css?family=Cardo&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Merriweather+Sans:ital,wght@0,300;0,400;1,300&family=Merriweather:ital,wght@0,300;0,400;1,300&display=swap');

$navbar-background-color: transparent;
/* $card-shadow: none; */
@import '~bulma';
@import '~@fortawesome/fontawesome-free/css/all.css';
@import '@/assets/css/_colors.scss';
$fa-font-path: '~font-awesome/fonts';

$font-main: 'acuta';
$font-second: 'Merriweather';
$font-tertiary: 'Cardo';
$font-ruhl: 'Frank Ruhl Libre';
@font-face {
  font-family: EzraSILW;
  src: url('./assets/fonts/SILEOT.woff');
}

$mediaMaxWidth: 1260px;
$mediaBp1Width: 960px;
$mediaMinWidth: 480px;
@function translate-media-condition($c) {
  $condmap: (
    'screen': 'only screen',
    'print': 'only print',
    'retina':
      '(-webkit-min-device-pixel-ratio: 1.5), (min--moz-device-pixel-ratio: 1.5), (-o-min-device-pixel-ratio: 3/2), (min-device-pixel-ratio: 1.5), (min-resolution: 120dpi)',
    '>maxwidth': '(min-width: #{mediaMaxWidth + 1})',
    '<maxWidth': '(max-width: #{mediaMaxWidth})',
    '>bp1Widtdh': '(min-width: #{mediaBp1Width + 1})',
    '<bp1Width': '(max-width: #{mediaBp1Width})',
    '>minWidth': '(min-width: #{mediaMinWidth + 1})',
    '<minWidth': '(max-width: #{mediaMinWidth})',
  );
  @return map-get($condmap, $c);
}

@mixin media($args...) {
  $query: '';
  @each $arg in $args {
    $op: '';
    @if ($query != '') {
      $op: ' and ';
    }
    $query: $query + $op + translate-media-condition($arg);
  }
  @media #{$query} {
    @content;
  }
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.font-main {
  font-family: $font-main, serif;
  font-weight: 400;
  font-style: normal;
  &--italic {
    @extend .font-main;
    font-style: italic;
  }
  &--bold {
    @extend .font-main;
    font-weight: 700;
  }
  &--bi {
    @extend .font-main;
    font-weight: 700;
    font-style: italic;
  }
}
.font-second {
  font-family: $font-second, serif;
  &--italic {
    @extend .font-second;
    font-style: italic;
  }
  &--bold {
    @extend .font-second;
    font-weight: 700;
  }
  &--bi {
    @extend .font-second;
    font-weight: 700;
    font-style: italic;
  }
}
.font-tertiary {
  font-family: $font-tertiary;
}
.font-hebrew {
  font-family: 'EzraSILW';
  font-weight: 800;
}
.main-link {
  padding: 0.25em;
}
.click {
  cursor: pointer;
}

.rf-button {
  color: $primary;
  margin-bottom: 0.5em;
  & > button,
  a {
    display: inline;
    outline: none;
    border: 1px solid $primary;
    padding: 6px 12px;
    text-align: center;
    margin-right: 1em;
    transition: all 0.3s ease;
    color: $primary;
    text-decoration: none;
    &:hover {
      background-color: $primary;
      color: white;
      padding: 6px 1.5em;
    }
  }
}
</style>
